import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // Temporarily disable StrictMode to test if it's causing duplicate API calls
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);